import $ from 'jquery';
import { breakpoints } from './_site';

export let cleared = false;
export const binds = () => {

    // $('.exitModal').on('hidden.bs.modal', function () {
    //     $('#consultation-modal').modal('show');
    // });

    $('body').on('mouseout', function (e) {
        var from = e.relatedTarget || e.toElement;

        if (!cleared && $(window).width() >= breakpoints.md) {
            if (!from || from.nodeName == 'HTML') {
                console.log(event);
                // stop your drag event here
                // for now we can just use an alert
                $('.exitModal').modal('show');
                cleared = true;
            }
        }

    });
};
